import { useTranslation } from 'react-i18next';
import { formatCents } from '@/lib/format';
import type { CampaignCpmRates } from '@/lib/campaigns/describeCampaignCpmRates';
import { CampaignCpmRateList } from './CampaignCpmRateList';

type Props = {
  rates: CampaignCpmRates;
  currency: string;
  /** effective ÷ nominal CPM; only meaningful when the campaign has one rate. */
  efficiency: number | null;
};

const formatPercent = (value: number | null) => (value === null ? '—' : `${Math.round(value * 100)}%`);

/**
 * Line under the admin "effective CPM" card. With one rate it compares the
 * effective CPM with it; with per-network rates there is no single nominal to
 * compare against, so it lists the networks instead.
 */
export function EffectiveCpmHint({ rates, currency, efficiency }: Props) {
  const { t } = useTranslation();
  if (rates.kind === 'single') {
    return (
      <p className="text-xs text-muted-foreground">
        {t('admin.campaigns.submissions.summary.effectiveCpmHint', {
          nominal: formatCents(rates.rateCents, currency),
          efficiency: formatPercent(efficiency),
        })}
      </p>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-x-1.5 text-xs text-muted-foreground">
      <span>{t('admin.campaigns.submissions.summary.effectiveCpmNominalPerPlatform')}</span>
      <CampaignCpmRateList rates={rates.rates} currency={currency} />
    </div>
  );
}
